/* tslint:disable max-line-length */
import { SearchOptions } from '@/interfaces/components/translations/SearchOptions';

export const ApiRoutes = {
    login: '/auth/login',
    refreshToken: '/auth/refresh-token',
    getProductCategories:
        '/product/categories?include=products,products.icon,products.productForm,products.productSystems,products.productSystems.productSystemDetails,products.productSystems.productSystemDetails.icon,products.productSystems.product,products.productForm.gallery',
    getBasicProductCategories: '/product/categories',
    getProductCategoriesWithoutIcons:
        '/product/categories?include=products,products.productForm,products.icon,products.productSystems,products.productSystems.productSystemDetails.icon,products.productSystems,products.productSystems.product',
    createNewProject:
        '/projects?include=label,madeByUser,lead,client,client.clientTypes,client.paymentType,client.address,client.address.country,contactPerson,client.contactPersons,client.priceListRegion,client.priceType',
    createNewLead: '/leads',
    updateLead(id: string) {
        return `/leads/${id}?include=origin,products,campaign,leadType,attachments,objectAddress,objectAddress.country`;
    },
    getProductForms:
        '/product/forms?include=checklists,checklists.checklistSegments,checklists.checklistSegments.checklistFields,checklists.checklistSegments.checklistFields.checklistBoolField,checklists.checklistSegments.checklistFields.checklistStringField,checklists.checklistSegments.checklistFields.checklistFloatField,checklists.checklistSegments.checklistFields.checklistDropdownField,checklists.checklistSegments.checklistFields.checklistIntegerField,checklists.checklistSegments.checklistFields.checklistDropdownField.checklistDropdownOptions,checklists.checklistSegments.checklistFields.checklistVisibleFunction,checklists.checklistSegments.checklistFields.checklistUpdateFunctions,checklists.checklistSegments.checklistFields.checklistVisibleFunction&filter[isArchived]=0,gallery',
    getProductForm(productFormId: number) {
        return `/product/forms/${productFormId}?include=checklists,checklists.checklistSegments,checklists.checklistSegments.checklistFields,checklists.checklistSegments.checklistFields.checklistBoolField,checklists.checklistSegments.checklistFields.checklistStringField,checklists.checklistSegments.checklistFields.checklistFloatField,checklists.checklistSegments.checklistFields.checklistDropdownField,checklists.checklistSegments.checklistFields.checklistIntegerField,checklists.checklistSegments.checklistFields.checklistDropdownField.checklistDropdownOptions,checklists.checklistSegments.checklistFields.checklistVisibleFunction,checklists.checklistSegments.checklistFields.checklistUpdateFunctions,checklists.checklistSegments.checklistFields.image,gallery`;
    },
    getProductFromFromProduct(productId: string) {
        return `/products/${productId}?include=productForm,productForm.checklists,productForm.checklists.checklistSegments,productForm.checklists.checklistSegments.checklistFields,productForm.checklists.checklistSegments.checklistFields.checklistBoolField,productForm.checklists.checklistSegments.checklistFields.checklistStringField,productForm.checklists.checklistSegments.checklistFields.checklistFloatField,productForm.checklists.checklistSegments.checklistFields.checklistDropdownField,productForm.checklists.checklistSegments.checklistFields.checklistIntegerField,productForm.checklists.checklistSegments.checklistFields.checklistDropdownField.checklistDropdownOptions,productForm.checklists.checklistSegments.checklistFields.checklistVisibleFunction,productForm.checklists.checklistSegments.checklistFields.checklistUpdateFunctions,productForm.checklists.checklistSegments.checklistFields.image`;
    },
    getProductFormImage(productFormId: number) {
        return `/product/forms/${productFormId}?include=gallery`;
    },
    updateProductForms: '/product/forms/update',
    importJavascriptFunctions: '/import/javascript/functions',
    importProductForms: '/import/product/forms',
    importMaterials: '/import/materials',
    importPriceLists: '/import/pricelists',
    importPriceListTypes: '/import/pricelist/types',
    importDiscounts: '/import/discounts',
    importTechnicalDocuments: '/import/technical/documents',
    importColors: '/import/colors',
    toggleColorImport: '/colors/import/toggle',
    colorImportStatus: '/colors/import/status',
    projects: {
        chatProjects(query: string) {
            return `/projects?include=lead,offerRevisions,client,assignedUser,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.nextStep.type,chat.messages,chat.messages.nextStep.madeByUser,chat.messages.nextStep.assignedUser,chat.messages.content.attachments&filter[temporary]=0${query}`;
        },
        getProjectInfo(projectId: number) {
            return `/projects/${projectId}/getProjectInfo`;
        },
        leadProjects: `/projects?include=lead,offerRevisions,client,client.clientTypes,label,orderStatus,assignedUser,offerRevisions.offerItems,client.currency&filter[state]=lead&page[size]=10&filter[temporary]=0`,
        adminProjects: `/projects?include=lead,offerRevisions,client,client.address,label,orderStatus,assignedUser,offerRevisions.offerItems,client.currency&filter[state]=lead&page[size]=10&filter[temporary]=0`,
        offerProjects: `/projects?include=lead,offerRevisions,client,label,orderStatus,client.currency&filter[state]=offer&page[size]=10`,
        offerAndRequestProjects: `/projects?include=lead,offerRevisions,client,label,orderStatus,client.currency&q=state:offer|state:request&page[size]=10`,
        orderProjects: `/projects?include=projectInternalOrders,lead,offerRevisions,client,label,orderStatus,client.currency&filter[state]=order&page[size]=10`,
        activitiesProjects: `/projects?include=lead,offerRevisions,client,label,lead.nextStepType,client.currency&q=state:lead|state:offer|state:order^(lead.nextStepName<>null)&[size]=10&filter[temporary]=0`,
        filterProjects(query: string) {
            return `/projects?include=lead,offerRevisions,client,client.priceListRegion,client.priceType,client.priceType,client.paymentType,client.clientTypes,label,assignedUser,offerRevisions.offerItems,client.address,lead.products,orderStatus,nextSteps,nextSteps.type,lead.origin,lead.leadType,lead.campaign,client.currency${query}`;
        },
        filterLeadProjects(query: string) {
            return `/projects?include=lead,client,client.clientTypes,label,assignedUser,nextSteps,client.address,contactPerson${query}`;
        },
        filterOfferProjects(query: string) {
            return `/projects?include=offerRevisions,client,label,assignedUser,client.address,contactPerson,offerRevisions.sellingOfferPrice${query}`;
        },
        filterRequestProjects(query: string) {
            return `/projects?include=offerRevisions,offerRevisions.sellingOfferPrice,offerRevisions.purchaseOfferPrice,client,label,assignedUser,madeByUser,client.address,client.address.country,client.priceType,client.priceListRegion,client.priceType,client.contactPersons${query}`;
        },
        filterOrderProjects(query: string) {
            return `/projects?include=projectInternalOrders,orderStatus,client,assignedUser,offerRevisions,client.address,contactPerson,offerRevisions.sellingOfferPrice${query}`;
        },
        filterAdminProjects(query: string) {
            return `/projects?include=lead,client,client.address,contactPerson,lead.products,assignedUser${query}`;
        },
        filterAllProjects(query: string) {
            return `/projects?include=client.address,contactPerson,assignedUser,label,orderStatus,offerRevisions.sellingOfferPrice${query}`;
        },
        withoutIncludes(query: string) {
            return `/projects?${query}`;
        },
        getAll: '/projects?include=lead,offerRevisions,client&page[size]=1000',
        getSingleForLeadTab(id: string) {
            return `/projects/${id}?include=lead,bankAccount,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep.assignedUser,chat.messages.nextStep.reminderOption,chat.messages.nextStep.madeByUser,chat.messages.nextStep,chat.messages.nextStep.type,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,assignedUser,client,client.clientTypes,label,client.priceListRegion,client.priceType,client.paymentType,lead.attachments,madeByUser,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.pdf,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,nextSteps.reminderOption,client.currency,lead.attachments.lead,lead.objectAddress,lead.objectAddress.country,lead.origin,lead.products,lead.campaign,lead.leadType`;
        },
        getSingleWithAllLeadData(id: string) {
            return `/projects/${id}?include=lead,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,assignedUser,client,client.clientTypes,label,client.paymentType,lead.origin,lead.products,lead.campaign,lead.leadType,lead.attachments,madeByUser,lead.objectAddress,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.pdf,offerRevisions.priceManipulations,offerRevisions.priceManipulations.priceManipulationType,offerRevisions.priceManipulations.productCategory,offerRevisions.priceManipulations.offer,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,nextSteps.reminderOption,client.currency`;
        },
        getSingleWithAllLeadAndOfferData(id: string) {
            return `/projects/${id}?include=architect,lead,bankAccount,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.nextStep.madeByUser,chat.messages.nextStep.type,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,offerRevisions.offerItems,offerRevisions.paymentType,assignedUser,client,client.priceListRegion,client.priceType,client.clientTypes,offerRevisions.offerItems.offerItemPrice,offerRevisions.offerItems.offerItemPriceManipulations,offerRevisions.offerItems.offerItemPriceManipulations.priceManipulationType,label,client.paymentType,lead.origin,lead.products,lead.campaign,lead.leadType,lead.attachments,madeByUser,lead.objectAddress,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.offerItems.productSystem,offerRevisions.offerItems.productSystem.product,offerRevisions.offerItems.productSystem.product.productForm,offerRevisions.pdf,offerRevisions.montage,offerRevisions.offerItems.material,offerRevisions.offerItems.material.image,offerRevisions.deliveryAddress,offerRevisions.billingAddress,offerRevisions.offerItems.offerItemPrice,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,offerRevisions.offerTitles,client.currency,offerRevisions.sellingPriceManipulations,offerRevisions.sellingPriceManipulations.priceManipulationType,offerRevisions.sellingPriceManipulations.productCategory,offerRevisions.sellingPriceManipulations.offer,offerRevisions.purchasePriceManipulations,offerRevisions.purchasePriceManipulations.priceManipulationType,offerRevisions.purchasePriceManipulations.productCategory,offerRevisions.purchasePriceManipulations.offer`;
        },
        getSingle(id: string) {
            return `/projects/${id}?include=lead,bankAccount,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.nextStep.assignedUser,chat.messages.nextStep.reminderOption,chat.messages.nextStep.type,chat.messages.nextStep.madeByUser,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,offerRevisions.offerItems,offerRevisions.paymentType,assignedUser,client,client.priceListRegion,client.priceType,client.clientTypes,client.contactPersons,label,client.paymentType,lead.attachments,lead.attachments.lead,madeByUser,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.offerItems.productSystem,offerRevisions.orderPdf,offerRevisions.offerItems.productSystem.product,offerRevisions.offerItems.productSystem.product.productForm,offerRevisions.pdf,offerRevisions.montage,offerRevisions.offerItems.material,offerRevisions.offerItems.material.image,offerRevisions.deliveryAddress,offerRevisions.billingAddress,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,nextSteps.assignedUser,nextSteps.madeByUser,nextSteps.reminderOption,offerRevisions.offerTitles,client.currency,offerRevisions.offerItems.offerItemPrice,offerRevisions.sellingPriceManipulations,offerRevisions.sellingPriceManipulations.priceManipulationType,offerRevisions.sellingPriceManipulations.productCategory,offerRevisions.sellingPriceManipulations.offer,offerRevisions.purchasePriceManipulations,offerRevisions.purchasePriceManipulations.priceManipulationType,offerRevisions.purchasePriceManipulations.productCategory,offerRevisions.purchasePriceManipulations.offer`;
        },
        getForNextStep(id: string) {
            return `/projects/${id}?include=client,chat,client.address,nextSteps,nextSteps.type,nextSteps.assignedUser,nextSteps.madeByUser,nextSteps.reminderOption`;
        },
        updateExisting(projectId: string) {
            return `/projects/${projectId}?include=lead,offerRevisions,client,label,bankAccount`;
        },
        updateRoltekAPP(projectId: string) {
            return `/projects/${projectId}/roltekHelp`;
        },
        delete(projectId: string) {
            return `/projects/${projectId}`;
        },
        getByClient(clientId: string) {
            return `/projects?include=client&filter[client.id]=${clientId}`;
        },
        fetchForProjectView(id: string) {
            return `/projects/${id}?include=architect,lead.origin,lead.products,lead.campaign,lead.leadType,lead.attachments,lead.objectAddress,offerRevisions.paymentRecords,paymentRecords.currency,offerRevisions.offerItems.offerItemPriceManipulations,offerRevisions.offerItems.offerItemPriceManipulations.priceManipulationType,offerRevisions.offerNote,projectInternalOrders,projectInternalOrders.projectInternalOrderDates,projectInternalOrders.orderStatus,projectInternalOrders.attachments,lead,bankAccount,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.nextStep.assignedUser,chat.messages.nextStep.reminderOption,chat.messages.nextStep.type,chat.messages.nextStep.madeByUser,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,offerRevisions.offerItems,offerRevisions.paymentType,assignedUser,client,client.priceListRegion,client.priceType,client.clientTypes,client.contactPersons,label,client.paymentType,lead.attachments,lead.attachments.lead,madeByUser,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.offerItems.productSystem,offerRevisions.orderPdf,offerRevisions.offerItems.productSystem.product,offerRevisions.offerItems.productSystem.product.productForm,offerRevisions.pdf,offerRevisions.montage,offerRevisions.offerItems.material,offerRevisions.offerItems.material.image,offerRevisions.deliveryAddress,offerRevisions.billingAddress,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,nextSteps.assignedUser,nextSteps.madeByUser,nextSteps.reminderOption,offerRevisions.offerTitles,client.currency,offerRevisions.offerItems.offerItemPrice,offerRevisions.sellingPriceManipulations,offerRevisions.sellingPriceManipulations.priceManipulationType,offerRevisions.sellingPriceManipulations.productCategory,offerRevisions.sellingPriceManipulations.offer,offerRevisions.purchasePriceManipulations,offerRevisions.purchasePriceManipulations.priceManipulationType,offerRevisions.purchasePriceManipulations.productCategory,offerRevisions.purchasePriceManipulations.offer,offerRevisions.billingAddress.country,offerRevisions.deliveryAddress.country,offerRevisions.offerItems.offerItemPriceManipulations,offerRevisions.offerItems.offerItemPriceManipulations.priceManipulationType,lead.campaign,lead.leadType,lead.objectAddress,lead.origin,lead.products`;
        },
        updateClientAndContactPerson(id: string) {
            return `/projects/${id}?include=contactPerson,client,client.contactPersons,client.clientTypes,client.paymentType,client.address,client.address.country`;
        },
        getForTable(query: string) {
            return `project/search/${query.replace('&', '?')}`;
        },
        getForExtendedPrint(query: string) {
            return `project/search/?include=projectLogs,projectInternalOrders${query}`;
        },
        getSingleWithGeneralInfo(id: string) {
            return `/projects/${id}?include=orderStatus,label,chat,chat.messages,contactPerson,client,client.clientTypes,client.address,client.address.country,assignedUser,madeByUser`;
        },
        getSingleWithLeads(id: string) {
            return `/projects/${id}?include=lead,lead.campaign,lead.leadType,lead.objectAddress,lead.origin,lead.products,lead.attachments,lead.attachments.lead,assignedUser,madeByUser`;
        },
        getSingleWithOrders(id: string) {
            return `/projects/${id}?include=projectInternalOrders,projectInternalOrders.orderStatus,projectInternalOrders.attachments,assignedUser,madeByUser`;
        },
        getSingleWithPaymentRecords(id: string) {
            return `/projects/${id}?include=paymentRecords,paymentRecords.currency`;
        },
        getSingleForOfferTabWithoutOfferItems(id: string) {
            return `/projects/${id}?include=offerRevisions.sellingOfferPrice,offerRevisions.purchaseOfferPrice,label,assignedUser,madeByUser,client.priceType,client.priceListRegion`;
        },
        getSingleWithOfferItems(id: string) {
            return `/projects/${id}?include=bankAccount,chat,chat.messages,chat.messages.content,chat.messages.madeByUser,chat.messages.nextStep,chat.messages.nextStep.assignedUser,chat.messages.nextStep.reminderOption,chat.messages.nextStep.type,chat.messages.nextStep.madeByUser,chat.messages.content.attachments,offerRevisions,offerRevisions.purchaseOfferPrice,offerRevisions.sellingOfferPrice,offerRevisions.offerItems,offerRevisions.paymentType,assignedUser,client,client.priceListRegion,client.priceType,client.clientTypes,client.contactPersons,label,client.paymentType,lead.attachments,lead.attachments.lead,madeByUser,client.address,client.address.country,orderStatus,contactPerson,nextSteps,offerRevisions.offerItems.productSystem,offerRevisions.orderPdf,offerRevisions.offerItems.productSystem.product,offerRevisions.offerItems.productSystem.product.productForm,offerRevisions.pdf,offerRevisions.montage,offerRevisions.offerItems.material,offerRevisions.offerItems.material.image,offerRevisions.deliveryAddress,offerRevisions.billingAddress,offerRevisions.pdf.documentName,offerRevisions.pdf.offerConfiguration,nextSteps.type,nextSteps.assignedUser,nextSteps.madeByUser,nextSteps.reminderOption,offerRevisions.offerTitles,client.currency,offerRevisions.offerItems.offerItemPrice,offerRevisions.sellingPriceManipulations,offerRevisions.sellingPriceManipulations.priceManipulationType,offerRevisions.sellingPriceManipulations.productCategory,offerRevisions.sellingPriceManipulations.offer,offerRevisions.purchasePriceManipulations,offerRevisions.purchasePriceManipulations.priceManipulationType,offerRevisions.purchasePriceManipulations.productCategory,offerRevisions.purchasePriceManipulations.offer,offerRevisions.billingAddress.country,offerRevisions.deliveryAddress.country,offerRevisions.offerItems.offerItemPriceManipulations,offerRevisions.offerItems.offerItemPriceManipulations.priceManipulationType`;
        },
    },
    calculatePrice: '/price/calculator',
    checkForErrors: '/pdfs/check-errors',
    offer: {
        create: '/offers',
        getSingle(offerId: string) {
            return `offers/${offerId}?include=project,offerNote,sellingOfferPrice,orderPdf,purchaseOfferPrice,offerItems,offerItems.offerItemPrice,paymentType,offerItems.offerItemPriceManipulations,offerItems.offerItemPriceManipulations.priceManipulationType,offerItems.productSystem,offerItems.productSystem.product,offerItems.productSystem.product.productForm,pdf,montage,offerItems.material,offerItems.material.image,deliveryAddress,billingAddress,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory,purchasePriceManipulations.offer,pdf.documentName,pdf.offerConfiguration,offerTitles`;
        },
        getForOverviewTab(offerId: string) {
            return `offers/${offerId}?include=offerItems,sellingOfferPrice,purchaseOfferPrice,offerTitles,pdf,pdf.documentName`;
        },
        getForOffersTab(offerId: string) {
            return `offers/${offerId}?include=project,pdf,pdf.documentName,pdf.offerConfiguration,offerItems,offerTitles,offerItems.offerItemPrice,purchaseOfferPrice,sellingOfferPrice,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory`;
        },
        getByPaymentType(paymentTypeId: string) {
            return `offers/?filter[paymentType.id]=${paymentTypeId}&include=sellingOfferPrice,purchaseOfferPrice,offerItems,offerTitles,offerItems.productSystem,pdf,montage,offerItems.material,offerItems.material.image,deliveryAddress,billingAddress,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory,purchasePriceManipulations.offer,pdf.documentName,pdf.offerConfiguration`;
        },
        copy: (offerId: string) => {
            return `/offers/${offerId}?include=project,sellingOfferPrice,purchaseOfferPrice,paymentType,offerItems,offerTitles,offerItems.productSystem,offerItems.productSystem.product,offerItems.productSystem.product.productForm,pdf,montage,offerItems.material,offerItems.material.image,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory,purchasePriceManipulations.offer,offerItems.offerItemPrice,offerItems.offerItemPriceManipulations,offerItems.offerItemPriceManipulations.priceManipulationType,offerItems.material.image,deliveryAddress,billingAddress,deliveryAddress.country,billingAddress.country,pdf.documentName,pdf.offerConfiguration`;
        },
        copyToNewProject: (offerId: string) => {
            return `/projects/offer/${offerId}`;
        },
        delete: (offerId: string) => {
            return `/offers/${offerId}`;
        },
        finishAssistance: (offerId: string) => {
            return `/offers/finishRoltekControl/${offerId}`;
        },
        update: (offerId: string) => {
            return `/offers/${offerId}?include=offerNote,sellingOfferPrice,purchaseOfferPrice,paymentType,offerItems,offerTitles,offerItems.productSystem,pdf,montage,offerItems.material,offerItems.material.image,deliveryAddress,billingAddress,deliveryAddress.country,billingAddress.country,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory,purchasePriceManipulations.offer,pdf.documentName,pdf.offerConfiguration`;
        },
        order: (offerId: string) => {
            return `/offers/order/${offerId}?include=sellingOfferPrice,purchaseOfferPrice,paymentType,offerItems,offerTitles,offerItems.productSystem,pdf,montage,offerItems.material,offerItems.material.image,sellingPriceManipulations,sellingPriceManipulations.priceManipulationType,sellingPriceManipulations.productCategory,sellingPriceManipulations.offer,purchasePriceManipulations,purchasePriceManipulations.priceManipulationType,purchasePriceManipulations.productCategory,purchasePriceManipulations.offer`;
        },
        clearPriceManipulations: (offerId: string) => {
            return `/offers/${offerId}`;
        },
        clearMontage: (offerId: string) => {
            return `/offers/${offerId}`;
        },
        updateAddress: (offerId: string) => {
            return `/offers/${offerId}`;
        },
        pdf: (resourceId: string) => {
            return `/files/offer-pdf/${resourceId}`;
        },
        orderPdf: (resourceId: string) => {
            return `/files/order-pdf/${resourceId}`;
        },
        send: (offerId: string) => {
            return `offers/send/${offerId}`;
        },
        unlockOffer: (offerId: string) => {
            return `offers/order/unlock/${offerId}`;
        },
        orderByTechnologist: (offerId: string) => {
            return `offers/technologist/order/${offerId}`;
        },
        orderAccountingOffer: (offerId: string) => {
            return `/offers/accounting/order/${offerId}`;
        },
        xmlOrders: '/xml/transfers?include=client,offer',
    },
    offerItem: {
        create: '/offer/items?include=offer,productSystem,offerItemPrice,productSystem.product,productSystem.product.productForm,offer.sellingOfferPrice,offer.purchaseOfferPrice',
        createBulk(offerId: string) {
            return `/offer/items/bulk/${offerId}`;
        },
        updateBulk(offerId: string) {
            return `/offer/items/bulk/${offerId}`;
        },
        delete(offerItemId: string) {
            return `/offer/items/${offerItemId}`;
        },
        getSingle(offerItemId: string) {
            return `/offer/items/${offerItemId}?include=productSystem,offer`;
        },
        updateExisting(offerItemId: string) {
            return `offer/items/${offerItemId}?include=productSystem,offer,material,offerItemPrice,offer.sellingOfferPrice,offer.purchaseOfferPrice`;
        },
        duplicateExisting(offerItemId: string) {
            return `offer/items/${offerItemId}?include=productSystem,offer,material`;
        },
        updateRowNumbers() {
            return 'offer/items/row/numbers';
        },
        createMaterial:
            '/offer/items?include=offer,material,offerItemPrice,offerItemPriceManipulations,offerItemPriceManipulations.priceManipulationType,offer,offer.sellingOfferPrice,offer.purchaseOfferPrice',
    },
    lead: {
        pdf(leadId: string) {
            return `/leads/${leadId}/print`;
        },
        leadAdditionalData(leadId: string) {
            return `/leads/${leadId}?include=origin,products,campaign,leadType,objectAddress,attachments,attachments.lead,objectAddress.country`;
        },
        deleteObjectAddress(leadId: string) {
            return `/leads/${leadId}`;
        },
        updateExisting(leadId: string) {
            return `/leads/${leadId}?include=origin,products,campaign,leadType`;
        },
    },
    product: {
        get: '/products?include=icon',
        getSingle(productId: string) {
            return `/products/${productId}`;
        },
        searchByProductNameOrProductSystemName(query: string) {
            const extendedQuery = `%${query}%`;
            return `/products?include=productSystems&q=name:${encodeURI(extendedQuery)}`;
        },
    },
    productSystem: {
        get: '/product/systems?filter[isArchived]=false',
        getSingle(productSystemId: string) {
            return `/product/systems/${productSystemId}?include=productSystemDetails,productSystemDetails.pdfOfferImage,productSystemDetails.icon,productSystemDetails.catalogueImage,productSystemDetails.documents,productSystemDetails.gallery,productSystemDetails.configurations&filter[isArchived]=false`;
        },
    },
    client: {
        getAll: '/clients?sort=name&page[size]=10&include=address,priceType,priceListRegion,currency,contactPersons,clientTypes,address.country,contactPersons.address,assignedUser',
        getAllOnlyClients: '/clients?sort=name&page[size]=10',
        filterOnlyClients(query: string) {
            return `/clients?${query}&include=clientTypes`;
        },
        filterClients(query: string) {
            return `/clients?${query}&include=address,contactPersons,address.country,clientTypes`;
        },
        getSingle(clientId: string) {
            return `/clients/${clientId}?include=clientLogs,origin,backofficeUser,priceListRegion,priceType,paymentType,assignedUser,clientTypes,address,address.country,deliveryAddress,deliveryAddress.country,invoiceAddress,invoiceAddress.country,currency,contactPersons,contactPersons.address,contactPersons.address.country,discounts,discounts.productGroup`;
        },
        getSingleForClientScreen(clientId: string) {
            return `/clients/${clientId}?include=assignedUser,origin,clientTypes,address,address.country,deliveryAddress,deliveryAddress.country,invoiceAddress,invoiceAddress.country`;
        },
        getSingleForConfigurator(clientId: string) {
            return `/clients/${clientId}?include=priceListRegion,paymentType`;
        },
        updateExisting(clientId: string) {
            return `clients/${clientId}`;
        },
        sendToIngenious(clientId: string) {
            return `clients/send/${clientId}`;
        },
        create: '/clients?include=paymentType,contactPersons',
        delete(clientId: string) {
            return `/clients/${clientId}`;
        },
        fetchByPaymentType(paymentTypeId: string) {
            return `/clients?filter[paymentType.id]=${paymentTypeId}include=paymentType`;
        },
        search(query: string) {
            return `/clients?include=assignedUser,paymentType,address,address.country,contactPersons${query}`;
        },
        searchNew(query: string) {
            return `/clients?include=address,address.country,contactPersons${query}`;
        },
        validateEmail(input: string) {
            return `/clients?filter[contactPersons.email]=${encodeURIComponent(
                `${input}`,
            )}&include=priceListRegion,priceType,paymentType,clientTypes,address,address.country,currency,contactPersons.projects`;
        },
        validateClient(input: string) {
            return `/clients?q=${encodeURIComponent(
                input,
            )}&include=priceListRegion,priceType,paymentType,clientTypes,address,address.country,currency,contactPersons.projects`;
        },
    },
    priceType: {
        get: '/price/types',
    },
    offerItemPriceType: {
        get: 'offer/item/prices/types',
        getById(offerItemPriceTypeId: string) {
            return `offer/item/prices/types/${offerItemPriceTypeId}`;
        },
    },
    priceListRegion: {
        get: '/price/list/regions',
    },
    pdf: {
        add: `/pdfs`,
        preview: `/pdfs/preview`,
        download: 'pdfs/admin-offer-pdf',
        update(pdfId: string) {
            return `/pdfs/${pdfId}`;
        },
        calendarPDF: '/pdfs/measurement-plan',
    },
    orderPdf: {
        add: `/order/pdfs`,
        preview: `/order/pdfs/preview`,
        getById(offerId: string) {
            return `/order/pdfs/${offerId}`;
        },
        update(pdfId: string) {
            return `/order/pdfs/${pdfId}`;
        },
    },
    country: {
        getAll: '/countries?page[size]=300',
    },
    cmsUser: {
        getAll: '/users?include=postCodeConnections,postCodeConnections.country,currency',
        getAllForUserRights: '/users?include=userGroupConnections,userGroupConnections.userGroup&page[size]=200',
        getAllFromAllGroups: '/users/all?include=postCodeConnections,postCodeConnections.country,currency',
        getAllOnlyUsers: '/users',
        getSingle(userId: string) {
            return `/users/${userId}?filter[deletedAt]=null&include=locale,postCodeConnections,userGroupConnections,userGroupConnections.userGroup,currency,userGroupConnections.user,aliases,aliases.country`;
        },
        updateExisting(id: string) {
            return `users/${id}?include=locale,currency`;
        },
        resetPassword: '/passwords/reset',
        requestPassword: '/passwords/request-reset',
        create: '/users?include=locale,userGroupConnections,userGroupConnections.userGroup,currency',
        delete(id: string) {
            return `/users/${id}`;
        },
        search(query: string) {
            return `/users?filter[name][_like]=${encodeURI(`%${query}%`)}`;
            // filter may need changing
        },
        validateEmail(input: string) {
            return `/users?filter[email][_like]=${encodeURI(`%${input}%`)}`;
        },
    },
    montage: {
        create: '/montages?include=offer,offer.sellingOfferPrice,offer.purchaseOfferPrice',
        update(montageId: string) {
            return `/montages/${montageId}?include=offer,offer.sellingOfferPrice,offer.purchaseOfferPrice`;
        },
        delete(montageId: string) {
            return `/montages/${montageId}`;
            ``;
        },
    },
    productCatalogue: {
        search(query: string) {
            return `/product/catalogs?include=gallery&filter[description]=${encodeURI(
                `%${query}%`,
            )}&filter[isPurchase]=1&filter[disabledProduct]=0`;
        },
        searchOnlyMaterials(query: string) {
            return `/product/catalogs?filter[description]=${encodeURI(
                `%${query}%`,
            )}&filter[isPurchase]=1&filter[disabledProduct]=0`;
        },
    },
    translations: {
        get: '/translations/index',
        getByRoute({ query, baseLocale, locale, entityName, attribute, pageSize, page, showOnlyEmpty }: SearchOptions) {
            const encodedQuery = encodeURI(query);
            const searchRoute = '/translations/search';
            const defaultRoute = '/translations';
            const showOnlyEmptyRoute = '/translations/empty';

            let finalRoute = query === '' ? defaultRoute : searchRoute;
            if (showOnlyEmpty) {
                finalRoute = showOnlyEmptyRoute;
            }
            return `${finalRoute}?baseLocale=${baseLocale}&locale=${locale}&entityName=${entityName}&attribute=${attribute}&pageSize=${pageSize}&page=${page}&query=${encodedQuery}`;
        },
        update(baseLocale: string) {
            return `/translations?baseLocale=${baseLocale}`;
        },
    },
    labels: {
        get: '/project/labels',
        getAll: '/project/labels/all',
        getByProjectState(projectState: string) {
            return `/project/labels?filter[projectState]=${projectState}`;
        },
        getById(labelId: string) {
            return `/project/labels/${labelId}`;
        },
        update(labelId: string) {
            return `/project/labels/${labelId}`;
        },
        create: '/project/labels',
        delete(labelId: string) {
            return `/project/labels/${labelId}`;
        },
        fetchAvailableLabels(projectId: string) {
            return `/projects/${projectId}/labels`;
        },
    },
    projectLabelTemplates: {
        get: '/project/label/templates?include=locale',
        getById(projectLabelTemplateId: string) {
            return `/project/label/templates/${projectLabelTemplateId}?include=locale`;
        },
        update(projectLabelTemplateId: string) {
            return `/project/label/templates/${projectLabelTemplateId}`;
        },
        create: '/project/label/templates',
        delete(projectLabelTemplateId: string) {
            return `/project/label/templates/${projectLabelTemplateId}`;
        },
    },
    offerItemPriceManipulation: {
        get: '/offer/item/price/manipulations?include=priceManipulationType,offerItem,offerItemPriceType',
        getById(offerPriceManipulationId: string) {
            // tslint:disable-next-line:max-line-length
            return `/offer/item/price/manipulations/${offerPriceManipulationId}?include=priceManipulationType,offerItem,offerItemPriceType`;
        },
        update(offerPriceManipulationId: string) {
            // tslint:disable-next-line:max-line-length
            return `/offer/item/price/manipulations/${offerPriceManipulationId}?include=priceManipulationType,offerItem,offerItemPriceType`;
        },
        create: '/offer/item/price/manipulations?include=priceManipulationType,offerItem,offerItemPriceType',
        delete(offerPriceManipulationId: string) {
            return `/offer/item/price/manipulations/${offerPriceManipulationId}`;
        },
        deleteAll(offerItemId: string) {
            return `/offers/${offerItemId}/offer/item/price/manipulations`;
        },
    },
    priceManipulation: {
        selling: {
            get: '/offer/selling/price/manipulations?include=priceManipulationType,productCategory,offer',
            getById(priceManipulationId: string) {
                return `/offer/selling/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory,offer`;
            },
            update(priceManipulationId: string) {
                return `/offer/selling/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory,offer`;
            },
            create: '/offer/selling/price/manipulations?include=priceManipulationType,productCategory,offer',
            delete(priceManipulationId: string) {
                return `/offer/selling/price/manipulations/${priceManipulationId}`;
            },
        },
        purchase: {
            get: '/offer/purchase/price/manipulations?include=priceManipulationType,productCategory,offer',
            getById(priceManipulationId: string) {
                return `/offer/purchase/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory,offer`;
            },
            update(priceManipulationId: string) {
                return `/offer/purchase/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory,offer`;
            },
            create: '/offer/purchase/price/manipulations?include=priceManipulationType,productCategory,offer',
            delete(priceManipulationId: string) {
                return `/offer/purchase/price/manipulations/${priceManipulationId}`;
            },
        },
        automatic: {
            get: '/automatic/price/manipulations?include=priceManipulationType,productCategory',
            getById(priceManipulationId: string) {
                return `/automatic/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory`;
            },
            update(priceManipulationId: string) {
                return `/automatic/price/manipulations/${priceManipulationId}?include=priceManipulationType,productCategory`;
            },
            create: '/automatic/price/manipulations?include=priceManipulationType,productCategory',
            delete(priceManipulationId: string) {
                return `/automatic/price/manipulations/${priceManipulationId}`;
            },
        },
    },
    priceManipulationType: {
        get: '/price/manipulation/types',
        getById(priceManipulationTypeId: string) {
            return `/price/manipulation/types/${priceManipulationTypeId}`;
        },
    },
    reminderOption: {
        get: '/reminder/options',
        getById(reminderOptionId: string) {
            return `/reminder/options/${reminderOptionId}`;
        },
        update(reminderOptionId: string) {
            return `/reminder/options/${reminderOptionId}`;
        },
        create: '/reminder/options',
        delete(reminderOptionId: string) {
            return `/reminder/options/${reminderOptionId}`;
        },
    },
    address: {
        get: '/addresses',
        getById(addressId: string) {
            return `/addresses/${addressId}?include=country`;
        },
        update(addressId: string, withRelationships: boolean) {
            return `/addresses/${addressId}?include=country${
                withRelationships ? ',objectLeads,objectLeads.objectAddress,billingOffers,deliveryOffers' : ''
            }`;
        },
        delete(addressId: string) {
            return `/addresses/${addressId}?include=country`;
        },
        create(withRelationships: boolean) {
            return `/addresses?include=country${
                withRelationships ? ',objectLeads,objectLeads.objectAddress,deliveryOffers,billingOffers' : ''
            }`;
        },
    },
    contact: {
        get: '/contact/persons',
        getById(contactId: string) {
            return `/contact/persons/${contactId}?include=address`;
        },
        getByIdWithProjects(contactId: string) {
            return `/contact/persons/${contactId}?include=address,projects`;
        },
        update(contactId: string) {
            return `/contact/persons/${contactId}`;
        },
        create: '/contact/persons',
        delete(contactId: string) {
            return `/contact/persons/${contactId}`;
        },
    },
    leadOrigin: {
        get: 'lead/origins',
        getById(leadOriginId: string) {
            return `/lead/origins/${leadOriginId}`;
        },
        update(leadOriginId: string) {
            return `/lead/origins/${leadOriginId}`;
        },
        delete(leadOriginId: string) {
            return `/lead/origins/${leadOriginId}`;
        },
        create: 'lead/origins',
    },
    plainMessage: {
        get: 'plain/messages',
        getById(plainMessageId: string) {
            return `/plain/messages/${plainMessageId}`;
        },
        update(plainMessageId: string) {
            return `/plain/messages/${plainMessageId}`;
        },
        delete(plainMessageId: string) {
            return `/plain/messages/${plainMessageId}`;
        },
        create: 'plain/messages',
    },
    emailTemplateProperty: {
        get: '/email/template/properties?include=locale',
        getById(emailTemplatePropertyId: string) {
            return `/email/template/properties/${emailTemplatePropertyId}?include=locale`;
        },
        update(emailTemplatePropertyId: string) {
            return `/email/template/properties/${emailTemplatePropertyId}?include=locale`;
        },
        delete(emailTemplatePropertyId: string) {
            return `/email/template/properties/${emailTemplatePropertyId}?include=locale`;
        },
        create: '/email/template/properties?include=locale',
    },
    productGroup: {
        get: '/product/groups',
        getById(productGroupId: string) {
            return `/product/groups/${productGroupId}`;
        },
        update(productGroupId: string) {
            return `/product/groups/${productGroupId}`;
        },
        delete(productGroupId: string) {
            return `/product/groups/${productGroupId}`;
        },
        create: '/product/groups',
    },
    message: {
        get: 'chat/messages',
        getById(messageId: string) {
            return `chat/messages/${messageId}`;
        },
        update(messageId: string) {
            return `chat/messages/${messageId}`;
        },
        delete(messageId: string) {
            return `chat/messages/${messageId}`;
        },
        create: 'chat/messages',
    },
    chat: {
        get: 'chats',
        getById(chatId: string) {
            return `/chats/${chatId}?include=project,project.chat,project.lead,project.offerRevisions,project.client,project.assignedUser,messages,messages.content,messages.madeByUser,messages.nextStep,messages.content.attachments`;
        },
        update(chatId: string) {
            return `/chats/${chatId}`;
        },
        delete(chatId: string) {
            return `/chats/${chatId}`;
        },
        create: 'chats?include=project,project.lead,project.offerRevisions,project.client,project.assignedUser,messages,messages.content,messages.madeByUser,messages.nextStep,messages.content.attachments',
    },
    workflow: {
        get: 'workflows?include=systemNodes,projectLabelNodes,connections,projectLabelNodes.projectLabel',
        getById(workflowId: string) {
            return `/workflows/${workflowId}`;
        },
        update(workflowId: string) {
            // tslint:disable-next-line:max-line-length
            return `/workflows/${workflowId}?include=systemNodes,projectLabelNodes,connections,projectLabelNodes.projectLabel`;
        },
        delete(workflowId: string) {
            return `/workflows/${workflowId}`;
        },
        create: '/workflows',
    },
    workflowTemplate: {
        get: 'workflow/templates?include=systemNodes,projectLabelTemplateNodes,connections,projectLabelTemplateNodes.projectLabelTemplate,locale',
        getById(workflowTemplateId: string) {
            return `/workflow/templates/${workflowTemplateId}?include=systemNodes,projectLabelTemplateNodes,connections,projectLabelTemplateNodes.projectLabelTemplate,locale`;
        },
        getByLocale(localeId: string) {
            return `/workflow/templates?filter[locale.id]=${localeId}&include=systemNodes,projectLabelTemplateNodes,connections,projectLabelTemplateNodes.projectLabelTemplate,locale`;
        },
        update(workflowTemplateId: string) {
            return `/workflow/templates/${workflowTemplateId}?include=systemNodes,projectLabelTemplateNodes,connections,projectLabelTemplateNodes.projectLabelTemplate,locale`;
        },
        delete(workflowTemplateId: string) {
            return `/workflow/templates/${workflowTemplateId}`;
        },
        create: 'workflow/templates?include=systemNodes,projectLabelTemplateNodes,connections,projectLabelTemplateNodes.projectLabelTemplate,locale',
    },
    leadType: {
        get: 'lead/types',
        getById(leadTypeId: string) {
            return `/lead/types/${leadTypeId}`;
        },
        update(leadTypeId: string) {
            return `/lead/types/${leadTypeId}`;
        },
        delete(leadTypeId: string) {
            return `/lead/types/${leadTypeId}`;
        },
        create: 'lead/types',
    },
    currency: {
        get: 'currencies',
        getById(currencyId: string) {
            return `/currencies/${currencyId}`;
        },
        update(currencyId: string) {
            return `/currencies/${currencyId}`;
        },
        delete(currencyId: string) {
            return `/currencies/${currencyId}`;
        },
        create: 'currencies',
    },
    leadProduct: {
        get: 'lead/products',
        getById(leadProductId: string) {
            return `/lead/products/${leadProductId}`;
        },
    },
    campaigns: {
        get: '/campaigns?include=campaignType',
        getById(campaignTypeId: string) {
            return `/campaigns/${campaignTypeId}?include=campaignType`;
        },
        delete(campaignTypeId: string) {
            return `/campaigns/${campaignTypeId}?include=campaignType`;
        },
        update(campaignTypeId: string) {
            return `/campaigns/${campaignTypeId}?include=campaignType`;
        },
        create: '/campaigns?include=campaignType',
    },
    nextStepType: {
        get: '/next/step/types',
        getById(nextStepTypeId: string) {
            return `/next/step/types/${nextStepTypeId}`;
        },
        update(nextStepTypeId: string) {
            return `/next/step/types/${nextStepTypeId}`;
        },
        delete(nextStepTypeId: string) {
            return `/next/step/types/${nextStepTypeId}`;
        },
        create: '/next/step/types',
    },
    nextStep: {
        get: '/next/steps?include=type,project,project.contactPerson,project.client,project.client.address',
        getById(nextStepId: string) {
            return `/next/steps/${nextStepId}?include=project,assignedUser,madeByUser,reminderOption,type`;
        },
        update(nextStepId: string) {
            return `/next/steps/${nextStepId}?include=project,assignedUser,madeByUser,reminderOption,type`;
        },
        delete(nextStepId: string) {
            return `/next/steps/${nextStepId}?include=assignedUser,madeByUser,reminderOption,type`;
        },
        create: '/next/steps?include=assignedUser,madeByUser,reminderOption,type,project',
        filterNextStepProjects(query: string) {
            return `/next/steps?include=assignedUser,reminderOption,type,project,project.client${query}&page[size]=1000`;
        },
    },
    nextStepTemplate: {
        get: '/next-step-template',
        getById(nextStepTemplateId: string) {
            return `/next-step-template/${nextStepTemplateId}?include=type&ug=1`;
        },
        getByLabelId(labelId: string) {
            return `next-step-template?ug=1&include=type,statusEventActivityConfig&projectLabelId=${labelId}`;
        },
        create: '/next-step-template?include=assignedUser,madeByUser,reminderOption,type&ug=1',
        update(nextStepTemplateId: string) {
            return `/next-step-template/${nextStepTemplateId}`;
        },
    },
    introScreen: {
        get: '/intro/screens?include=introScreenItems,introScreenItems.orderStatus,introScreenItems.projectLabel',
        getById(introScreenId: string) {
            return `/intro/screens/${introScreenId}?include=introScreenItems,introScreenItems.orderStatus,introScreenItems.projectLabel`;
        },
        update(introScreenId: string) {
            return `/intro/screens/${introScreenId}`;
        },
        delete(introScreenId: string) {
            return `/intro/screens/${introScreenId}`;
        },
        create: '/intro/screens',
    },
    introScreenItem: {
        get: '/intro/screen/items',
        getById(introScreenItemId: string) {
            return `/intro/screen/items/${introScreenItemId}`;
        },
        update(introScreenItemId: string) {
            return `/intro/screen/items/${introScreenItemId}`;
        },
        delete(introScreenItemId: string) {
            return `/intro/screen/items/${introScreenItemId}`;
        },
        create: '/intro/screen/items',
    },
    clientType: {
        get: '/client/types',
        getById(clientTypeId: string) {
            return `/client/types/${clientTypeId}`;
        },
        update(clientTypeId: string) {
            return `/client/types/${clientTypeId}`;
        },
        delete(clientTypeId: string) {
            return `/client/types/${clientTypeId}`;
        },
        create: '/client/types',
    },
    clientAttachment: {
        get: '/client/attachments',
        getById(id: string) {
            return `/client/attachments/${id}`;
        },
        getAttachmentsByClientId(clientId: string) {
            return `/client/attachments?q=client.id:${clientId}`;
        },
        update(clientTypeId: string) {
            return `/client/attachments/${clientTypeId}`;
        },
        delete(clientTypeId: string) {
            return `/client/attachments/${clientTypeId}`;
        },
        create: '/client/attachments',
    },
    taxDetails: {
        get: '/tax/details',
        getById(taxDetailsId: string) {
            return `/tax/details/${taxDetailsId}`;
        },
        update(taxDetailsId: string) {
            return `/tax/details/${taxDetailsId}`;
        },
        delete(taxDetailsId: string) {
            return `/tax/details/${taxDetailsId}`;
        },
        create: '/tax/details',
    },
    campaignTypes: {
        get: '/campaign/types',
        getById(campaignTypeId: string) {
            return `/campaign/types/${campaignTypeId}`;
        },
        delete(campaignTypeId: string) {
            return `/campaign/types/${campaignTypeId}`;
        },
        update(campaignTypeId: string) {
            return `/campaign/types/${campaignTypeId}`;
        },
        create: '/campaign/types',
    },
    paymentType: {
        get: '/payment/types',
        getById(paymentTypeId: string) {
            return `/payment/types/${paymentTypeId}`;
        },
        fetchDefaultPaymentType: `/payment/types?filter[isDefault=1]`,
        delete(paymentTypeId: string) {
            return `/payment/types/${paymentTypeId}`;
        },
        update(paymentTypeId: string) {
            return `/payment/types/${paymentTypeId}`;
        },
        create: '/payment/types',
    },
    orderStatuses: {
        get: '/order/statuses',
        getById(orderStatusId: string) {
            return `/order/statuses/${orderStatusId}`;
        },
        delete(orderStatusId: string) {
            return `/order/statuses/${orderStatusId}`;
        },
        update(orderStatusId: string) {
            return `/order/statuses/${orderStatusId}`;
        },
        create: '/order/statuses',
    },
    paymentRecords: {
        get: '/payment/records?include=offer',
        getById(paymentRecordId: string) {
            return `/payment/records/${paymentRecordId}?include=currency,offer`;
        },
        delete(paymentRecordId: string) {
            return `/payment/records/${paymentRecordId}`;
        },
        update(paymentRecordId: string) {
            return `/payment/records/${paymentRecordId}?include=currency`;
        },
        create: '/payment/records?include=project,currency,offer',
    },
    offerTitles: {
        get: '/offer/titles',
        getById(offerTitleId: string) {
            return `/offer/titles/${offerTitleId}`;
        },
        delete(offerTitleId: string) {
            return `/offer/titles/${offerTitleId}`;
        },
        update(offerTitleId: string) {
            return `/offer/titles/${offerTitleId}`;
        },
        duplicate(offerTitleId: string) {
            return `/offer/titles/${offerTitleId}`;
        },
        create: '/offer/titles?include=offer,offer.offerTitles,offer.offerItems',
        updateRowNumbers() {
            return 'offer/titles/row/numbers';
        },
    },
    projectStates: {
        get: '/project/states',
    },
    productSystemDetails: {
        getAll: '/product/system/details?include=pdfOfferImage,icon,catalogueImage,productSystem,documents,configurations,configurations.image&filter[isArchived]=false',
        getSingle(productDetailsId: string) {
            return `/product/system/details/${productDetailsId}?include=pdfOfferImage,icon,catalogueImage,productSystem,documents,configurations,configurations.image&filter[isArchived]=false`;
        },
        updateExisting(productDetailsId: string) {
            return `product/system/details/${productDetailsId}?include=pdfOfferImage,icon,catalogueImage,productSystem,documents,configurations,configurations.image`;
        },
        create: '/product/system/details?include=pdfOfferImage,icon,catalogueImage,productSystem,documents,configurations,configurations.image',
    },
    image: {
        create: '/images',
        update(imageId: string) {
            return `/images/${imageId}`;
        },
    },
    awardImage: {
        create: '/award/images',
        update(awardImageId: string) {
            return `/award/images/${awardImageId}`;
        },
    },
    headerImage: {
        create: '/header/images',
        update(awardImageId: string) {
            return `/header/images/${awardImageId}`;
        },
    },
    attachments: {
        create: '/attachments?include=lead,lead.attachments',
        delete(attachmentId: string) {
            return `/attachments/${attachmentId}?include=lead`;
        },
        createPublic: '/attachments/public',
        getBlob(resourceId: string) {
            return `/files/attachment/${resourceId}`;
        },
        getAttachmentsByProjectId(projectId: string) {
            return `/attachments?q=lead.project.id:${projectId}`;
        },
    },
    locale: {
        get: '/locales',
    },
    uploadedPdf: {
        create: '/uploaded/pdfs',
        update(uploadedPdfId: string) {
            return `/uploaded/pdfs/${uploadedPdfId}`;
        },
    },
    cms: {
        checklistFields: {
            get: '/checklistFields?page[size]=1000&include=validWarranty,image,checklistSegment,checklistSegment.checklist,checklistSegment.checklist.productForm',
            single(checklistFieldId: string) {
                return `/checklistFields/${checklistFieldId}?include=image`;
            },
            update(checklistFieldId: string) {
                return `/checklistFields/${checklistFieldId}?include=image,checklistSegment,checklistSegment.checklist,checklistSegment.checklist.productForm`;
            },
        },
        productForm: {
            get: '/product/forms?include=checklists,checklists.checklistSegments,checklists.checklistSegments.checklistFields,checklists.checklistSegments.checklistFields.checklistSegment,checklists.checklistSegments.checklist,checklists.productForm&filter[isArchived]=0',
        },
        productSystemDetailsConfiguration: {
            update(productSystemDetailsConfigurationId: string) {
                return `/product/system/details/configurations/${productSystemDetailsConfigurationId}?include=image`;
            },
            create: `/product/system/details/configurations?include=image`,
        },
    },
    bankAccount: {
        get: 'bank/accounts',
        getById(bankAccountId: string) {
            return `/bank/accounts/${bankAccountId}`;
        },
        update(bankAccountId: string) {
            return `/bank/accounts/${bankAccountId}`;
        },
        delete(bankAccountId: string) {
            return `/bank/accounts/${bankAccountId}`;
        },
        create: '/bank/accounts',
    },
    userAlias: {
        get: 'user/aliases',
        getById(userAliasId: string) {
            return `/user/aliases/${userAliasId}`;
        },
        update(userAliasId: string) {
            return `/user/aliases/${userAliasId}`;
        },
        delete(userAliasId: string) {
            return `/user/aliases/${userAliasId}`;
        },
        create: '/user/aliases',
    },
    logs: {
        get: '/project/logs',
        getById(projectId: string) {
            return `/project/logs?filter[project.id]=${projectId}&sort=-createdAt&page[size]=2000`;
        },
    },
    functions: {
        get: '/javascript/functions',
    },
    taxes: {
        get: '/taxes?include=country',
        getById(taxId: string) {
            return `/taxes/${taxId}?include=country`;
        },
        update(taxId: string) {
            return `/taxes/${taxId}?include=country`;
        },
        create: '/taxes?include=country',
    },
    documentName: {
        get: '/document/names',
        getById(documentNameId: string) {
            return `/document/names/${documentNameId}`;
        },
        update(documentNameId: string) {
            return `/document/names/${documentNameId}`;
        },
        delete(documentNameId: string) {
            return `/document/names/${documentNameId}`;
        },
        create: '/document/names',
    },
    inquiry: '/send-inquiry',
    userGroup: {
        get: '/user/groups',
        getWithClients: '/user/groups?include=client,client.address,locale',
        getById(userGroupId: string) {
            return `/user/groups/${userGroupId}?include=client,locale`;
        },
        update(userGroupId: string) {
            return `/user/groups/${userGroupId}?include=client,locale`;
        },
        create: '/user/groups?include=client,locale',
        getByPeriod(startDate: string, endDate: string) {
            return `/user/groups?ug=1&dateFrom=${startDate}&dateTo=${endDate}`;
        },
    },
    offerConfiguration: {
        get: '/offer/configurations?include=currency,offerPdfProperties',
        getUnarchived: '/offer/configurations?include=currency&filter[isArchived]=0',
        getById(offerConfigurationId: string) {
            return `/offer/configurations/${offerConfigurationId}?include=offerPdfProperties,offerPdfProperties.headerImages,offerPdfProperties.awardImages,offerPdfProperties.logo,offerPdfProperties.locale,currency,bankAccount`;
        },
        update(offerConfigurationId: string) {
            return `/offer/configurations/${offerConfigurationId}`;
        },
        create: '/offer/configurations',
        duplicate(offerConfigurationId: string) {
            return `/offer/configurations/${offerConfigurationId}`;
        },
        delete(offerConfigurationId: string) {
            return `/offer/configurations/${offerConfigurationId}`;
        },
    },
    orderConfiguration: {
        get: '/order/configurations?include=currency,orderPdfProperties',
        getById(orderConfigurationId: string) {
            return `/order/configurations/${orderConfigurationId}?include=orderPdfProperties,orderPdfProperties.headerImages,orderPdfProperties.awardImages,orderPdfProperties.logo,orderPdfProperties.locale,currency,bankAccount`;
        },
        update(orderConfigurationId: string) {
            return `/order/configurations/${orderConfigurationId}`;
        },
    },
    offerPdfProperties: {
        get: '/offer/pdf/properties',
        getById(offerPdfPropertiesId: string) {
            return `/offer/pdf/properties/${offerPdfPropertiesId}`;
        },
        update(offerPdfPropertiesId: string) {
            return `/offer/pdf/properties/${offerPdfPropertiesId}`;
        },
        create: '/offer/pdf/properties',
        delete(offerPdfPropertiesId: string) {
            return `/offer/pdf/properties/${offerPdfPropertiesId}`;
        },
    },
    orderPdfProperties: {
        get: '/order/pdf/properties',
        getById(orderPdfPropertiesId: string) {
            return `/order/pdf/properties/${orderPdfPropertiesId}`;
        },
        update(orderPdfPropertiesId: string) {
            return `/order/pdf/properties/${orderPdfPropertiesId}`;
        },
        create: '/order/pdf/properties',
        delete(orderPdfPropertiesId: string) {
            return `/order/pdf/properties/${orderPdfPropertiesId}`;
        },
    },
    discount: {
        get: '/discounts?include=productGroup',
        getById(discountId: string) {
            return `/discounts/${discountId}?include=productGroup`;
        },
        update(discountId: string) {
            return `/discounts/${discountId}?include=productGroup`;
        },
        create: '/discounts?include=productGroup',
        delete(discountId: string) {
            return `/discounts/${discountId}?include=productGroup`;
        },
    },
    postCodeConnection: {
        get: '/post/code/connections?include=user,country',
        getById(postCodeConnectionId: string) {
            return `/post/code/connections/${postCodeConnectionId}?include=user,country`;
        },
        update(postCodeConnectionId: string) {
            return `/post/code/connections/${postCodeConnectionId}?include=user,country`;
        },
        create: '/post/code/connections?include=user',
        delete(postCodeConnectionId: string) {
            return `/post/code/connections/${postCodeConnectionId}?include=user,country`;
        },
    },
    userGroupConnection: {
        get: '/user/group/connections?include=user,userGroup',
        getById(userGroupConnectionId: string) {
            return `/user/group/connections/${userGroupConnectionId}?include=user,userGroup`;
        },
        update(userGroupConnectionId: string) {
            return `/user/group/connections/${userGroupConnectionId}?include=user,userGroup`;
        },
        create: '/user/group/connections?include=user,userGroup',
        delete(userGroupConnectionId: string) {
            return `/user/group/connections/${userGroupConnectionId}?include=user,userGroup`;
        },
    },
    reports: {
        get: '/statistic-reports?include=users',
        getTypes: '/statistic-reports/types',
        getById(reportId: string) {
            return `/statistic-reports/${reportId}?ug=1&include=users`;
        },
        update(reportId: string) {
            return `/statistic-reports/${reportId}`;
        },
        create: '/statistic-reports',
        delete(reportId: string) {
            return `statistic-reports/${reportId}`;
        },
    },
    news: {
        get: '/news?include=locale',
        getArchived: '/news/archived',
        getById(reportId: string) {
            return `/news/${reportId}?include=locale`;
        },
        create: '/news',
        createArchived(reportId: string) {
            return `/news/archive/${reportId}`;
        },
        update(reportId: string) {
            return `/news/${reportId}`;
        },
        delete(reportId: string) {
            return `/news/${reportId}`;
        },
        archiveOrActivate(reportId: string, shouldArchive: string) {
            return `/news/archive/${reportId}?archive=${shouldArchive}`;
        },
    },
    newsAttachment: {
        get: '/news/attachments',
        getById(id: string) {
            return `/news/attachments/${id}`;
        },
        getAttachmentsByNewsId(newsId: string) {
            return `/news/attachments?q=news.id:${newsId}`;
        },
        update(newsTypeId: string) {
            return `/news/attachments/${newsTypeId}`;
        },
        delete(newsTypeId: string) {
            return `/news/attachments/${newsTypeId}`;
        },
        create: '/news/attachments',
    },
    dashboard: {
        get: '/dashboard/list',
        getCurrent(userId: string | null = null) {
            return `/dashboard${userId ? `?user=${userId}` : ''}`;
        },
        getById(dashboardId: string, userId: string | null = null) {
            return `/dashboard/${dashboardId}${userId ? `?user=${userId}` : ''}`;
        },
        update: `/dashboards/?include=users`,
        delete(dashboardId: string) {
            return `/dashboards/${dashboardId}`;
        },
        createReport: '/dashboard/reports?ug=1',
        getReport(reportId: string, timeFrame: { year: any; week: any; month: any }, userId: string) {
            return `/dashboard-reports/data/${reportId}?year=${timeFrame.year}&week=${
                timeFrame.week === 'Current' ? '' : timeFrame.week
            }&month=${timeFrame.month === '/' ? '' : timeFrame.month}&user=${userId}`;
        },
        deleteReport(reportId: string) {
            return `/dashboard/reports/${reportId}?ug=1`;
        },
        updateReport(reportId: string) {
            return `/dashboard/reports/${reportId}?ug=1`;
        },
    },
    technicalDirectories: {
        get(directoryId: string) {
            return `/technical/directories?filter[parentDirectoryId]=${directoryId}`;
        },
        getById(directoryId: string) {
            return `/technical/directories/${directoryId}`;
        },
        root: `/technical/directories/root`,
    },
    technicalDirectoriesFilter: {
        getById(id: string) {
            return `/technical/files?include=directory&filter[directory.id]=${id}`;
        },
    },
    technicalFiles: {
        get(pageNum: any, perPage: any) {
            return `/technical/files?page[size]=${perPage}&page[number]=${pageNum}`;
        },
        getById(fieldId: string) {
            return `/technical/files/${fieldId}`;
        },
        searchBy(id: string, query: string, fileType: string = '') {
            const searchQuery = query.length > 3 ? `&filter[name]=${query}` : '';

            return `/technical/files/search?filter[directory]=${id}${searchQuery}&filter[fileTypes]=${fileType}`;
        },
        search(query: string, directory: any) {
            return `/technical/files/search?filter[name]=${query}&filter[directory]=${directory}`;
        },
        searchByDirectory(query: string, directory: any) {
            return `/technical/directories/search?filter[name]=${query}&filter[directory]=${directory}`;
        },
    },
    flaggedPdfValue: {
        get: '/flagged/pdf/values',
        getById(flaggedPdfValueId: string) {
            return `/flagged/pdf/values/${flaggedPdfValueId}`;
        },
        delete(flaggedPdfValueId: string) {
            return `/flagged/pdf/values/${flaggedPdfValueId}`;
        },
        create: '/flagged/pdf/values',
        update(flaggedPdfValueId: string) {
            return `/flagged/pdf/values/${flaggedPdfValueId}`;
        },
    },
    dropdownOption: {
        get: '/dropdown/options',
    },
    automaticEvents: {
        create: '/status-event-activity-config',
        get: '/status-event-activity-config',
        getById(id: string) {
            return `/status-event-activity-config/${id}`;
        },
        update(id: string) {
            return `/status-event-activity-config/${id}`;
        },
        delete(id: string) {
            return `/status-event-activity-config/${id}`;
        },
    },
    customerHistory: {
        get: '/client/logs',
    },
    schedule: {
        get: '/schedule?include=rule',
        create: '/schedule',
        getById(id: string) {
            return `/schedule/${id}?include=rule`;
        },
        getByUser(id: string) {
            return `/schedule/user/${id}?include=rule`;
        },
        getByResource(id: string) {
            return `/schedule/resource/${id}?include=rule`;
        },
        delete(id: string) {
            return `/schedule/${id}`;
        },
        update(id: string) {
            return `/schedule/${id}`;
        },
    },
    resource: {
        get: '/resource',
        create: '/resource',
        getById(id: string) {
            return `/resource/${id}`;
        },
        update(id: string) {
            return `/resource/${id}`;
        },
        delete(id: string) {
            return `/resource/${id}`;
        },
    },
    internalOrder: {
        getAttachment(id: string) {
            return `/project-internal-order-attachments/${id}?ug=1`;
        },
        getById(id: string) {
            return `/project-internal-order/${id}?ug=1&include=project,orderStatus,attachments,projectInternalOrderDates`;
        },
        create: '/project-internal-order?ug=1&include=project,attachments',
    },
    productSystemWizard: {
        get: '/product-system-window-wizard?include=productSystem,translations,translations.image',
        create: '/product-system-window-wizard',
        createImage: '/product-system-window-wizard/images',
        getImage(id: string) {
            return `/product-system-window-wizard/images/${id}`;
        },
        getByProductSystemId(id: string) {
            return `/product-system-window-wizard?include=productSystem,translations,translations.image&productSystemId=${id}`;
        },
        getById(id: string) {
            return `/product-system-window-wizard/${id}?include=productSystem,translations,translations.image`;
        },
        update(id: string) {
            return `/product-system-window-wizard/${id}`;
        },
    },
    clientInformation: {
        getById(taxID: string) {
            return `/client/getClientInformation/${taxID}`;
        },
    },
    warrantyWarning: {
        get(validWarranty: string, query: string = '') {
            return `/checklistValues?filter[validWarranty]=${validWarranty}&page[size]=50&${query}`;
        },
        getById(warrantyWarningId: string) {
            return `/checklistValues/${warrantyWarningId}`;
        },
        update(warrantyWarningId: string) {
            return `/checklistValues/${warrantyWarningId}`;
        },
    },
    register: {
        register: '/register/forms',
    },
    rule: {
        get: '/rule',
        create: '/rule',
        getById(id: string) {
            return `/rule/${id}`;
        },
        update(id: string) {
            return `/rule/${id}`;
        },
        delete(id: string) {
            return `/rule/${id}`;
        },
    },
    google: {
        auth: '/google/auth',
    },
    notification: {
        getUnread: '/notifications',
        getAll: '/notifications/all',
        updateAsRead: '/notifications/read',
        getUnreadCount: '/notifications/unread-count',
        setSettings: 'notifications/settings',
        getSettings: 'notifications/settings',
    },
    productVersion: {
        get: '/product/versions',
        materials(
            page: number = 1,
            pageSize: number = 10,
            filters?: { search?: string; commodityGroup?: string; productGroup?: string },
        ) {
            let url = `/product/versions/materials?page=${page}&pageSize=${pageSize}`;
            if (filters?.search) {
                url += `&search=${encodeURIComponent(filters.search)}`;
            }
            if (filters?.commodityGroup) {
                url += `&commodityGroup=${encodeURIComponent(filters.commodityGroup)}`;
            }
            if (filters?.productGroup) {
                url += `&productGroup=${encodeURIComponent(filters.productGroup)}`;
            }
            return url;
        },
        JSFunctions: '/product/versions/js-functions',
        productPrices: (id: string) => `product/versions/prices/${id}`,
    },
    offerNote: {
        get: '/offer/notes',
        getById(id: string) {
            return `/offer/notes/${id}`;
        },
        create: '/offer/notes',
        update(id: string) {
            return `/offer/notes/${id}`;
        },
        delete(id: string) {
            return `/offer/notes/${id}`;
        },
    },
    color: {
        get(query: string) {
            return `/colors/?include=powders.material,powders.colorCollection,powders.colorSurface,defaultPowder&page[size]=1000${query}`;
        },
        getPowders(query: string) {
            return `/colors/powders?include=colorCollection,colors,defaultColors,material,colorCollection,colorSurface&page[size]=1000${query}`;
        },
        getPowderPrices: '/colors/powder/prices',
        getSurfaces: '/colors/surfaces',
        getQualities: '/colors/qualities',
        getGlosses: '/colors/glosses',
        getEffects: '/colors/effects',
        getCharts: '/colors/charts',
        getCollections: '/colors/collections',
    },
    technologist: {
        get(id: string) {
            return `/technologist/orders/${id}`;
        },
        create: '/technologist/orders',
        update(id: string) {
            return `/technologist/orders/${id}`;
        },
        delete(id: string) {
            return `/technologist/orders/${id}`;
        },
    },
    backgroundImage: {
        getAll: '/background/images',
        create: '/background/images',
        delete(id: string) {
            return `/background/images/${id}`;
        },
    },
    calendar: {
        freeDays: '/next/steps/work-free-days?include=type',
    },
    latestColors: {
        get: '/chosen/colors?include=powder.colorCollection,powder.colorSurface,color&page[size]=10',
    },
};
